
<div class="body-container">
  <div class="body-content">

    <div class="logo">
      @if (this.mainHeaderLogo$ | async; as MainLogoUrl) {
        <img alt="{{mainHeaderLogoAlt$ | async}}"  src="{{ MainLogoUrl }}" />
      } @else {
        @if (currentLanguage==='en') {
          <img alt="{{'login.company_logo' | translate}}"  src="assets/images/uw-logo-en.svg" />
        }
        @if (currentLanguage==='fr') {
          <img alt="{{'login.company_logo' | translate}}"  src="assets/images/uw-logo-fr.svg" />
        }
      }
    </div>

    @if (this.mainHeaderLogo2$ | async; as MainLogoUrl2;) {
      <div  class="logo2">
        <img alt="{{mainHeaderLogo2Alt$ | async}}"  src="{{ MainLogoUrl2 }}" />
        <!-- <ng-container  *ngIf="MainLogoUrl2.displayLogo2">
        <img alt="{{mainHeaderLogo2Alt$ | async}}"  src="{{MainLogoUrl2.logo2}}" />
      </ng-container>
      <ng-container *ngIf="MainLogoUrl2.displayDefaultLogo">
        <img *ngIf="currentLanguage=='en'" alt="{{'login.company_logo' | translate}}"  src="assets/images/uw-logo-en.svg" />
        <img *ngIf="currentLanguage=='fr'" alt="{{'login.company_logo' | translate}}"  src="assets/images/uw-logo-fr.svg" />
      </ng-container> -->
    </div>
  }


  <div class="box1"></div>
  <div class="box2"></div>
  <div class="box3"></div>
  <div class="box4"></div>
  <div class="main">
    <div class="sideimage">
      <!-- <img alt="Welcome Side Image" src="assets/images/Layer_1.png" /> -->
    </div>
    <div class="login-side">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
</div>
